module.exports = __webpack_public_path__ + "img/Unterricht_Logo_Beta.3ef5f2dd.svg";